//
import SlSaleInvoiceModel from '@/models/Sale/SlSaleInvoice'

/**
 * This class describes a sl sale invoice.
 * @class      SlSaleInvoice (name)
 */
export default class SlSaleInvoice extends SlSaleInvoiceModel {

	/**
	 * Returns a list representation of the object.
	 * @return     {Object}  List representation of the object.
	 */
	static toList() {

		//
		this.appends = [
			'account_receivable'
		]

		//
		this.includes = [
			'g_state',
			'sl_customer',
			'sl_customer_branch_offices',
			'sl_detail_sale_invoices.wh_product',
		]

		//
		return this
	}
}